import {
  FiBarChart,
  FiFileText,
  FiFilter,
  FiGrid,
  FiLock,
  FiRefreshCw,
  FiTarget,
  FiZap
} from "react-icons/fi";
import { IconType } from "react-icons";
import {
  PIPELINE_BLOCKS,
  PipelineBlockDefinition
} from "components/pipeline-components/node-catalog";

export const CONVENIO_OPTIONS = [
  { label: "INSS", value: "INSS", color: "#2F80ED" },
  { label: "GOV", value: "GOV", color: "#4DA8A1" },
  { label: "FGTS", value: "FGTS", color: "#E24A4A" },
  { label: "CLT", value: "CLT", color: "#C9994A" }
];

export const TIPO_OPERACAO_OPTIONS = [
  "NOVO",
  "REFIN_CARTEIRA",
  "PORT",
  "SAQUE_RMC",
  "SAQUE_RCC"
];

export const COLOR_OPTIONS = [
  "#2F80ED",
  "#1B6B5A",
  "#3ABB78",
  "#7BC42A",
  "#F5A623",
  "#9B59B6",
  "#E06B9A",
  "#2C3E50"
];

export const ICON_OPTIONS: { key: string; icon: IconType }[] = [
  { key: "refresh", icon: FiRefreshCw },
  { key: "filter", icon: FiFilter },
  { key: "target", icon: FiTarget },
  { key: "file", icon: FiFileText },
  { key: "lock", icon: FiLock },
  { key: "grid", icon: FiGrid },
  { key: "chart", icon: FiBarChart },
  { key: "zap", icon: FiZap }
];

export const MAX_VISIVEL = 5;

export const AVAILABLE_BLOCKS: PipelineBlockDefinition[] =
  PIPELINE_BLOCKS.filter(
    (b) => !["START", "END", "SAQUE_COMPLEMENTAR"].includes(b.operation)
  );
